
import React from 'react';
import api from '../utils/api';
import { useToast } from './ToastProvider';
import Modal from './common/Modal';
import FormField from './common/FormField';
import { useForm } from './common/useForm';


const AddCarModal = ({ onClose, onSaved }) => {
  const { showToast } = useToast();
  const [form, handleChange, setForm] = useForm({ mark: '', plate: '', year: '' });
  const [loading, setLoading] = React.useState(false);
  const [error, setError] = React.useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await api.post('/car', form);
      showToast('Машин амжилттай нэмэгдлээ!', 'success');
      setForm({ mark: '', plate: '', year: '' });
      if (onSaved) onSaved();
    } catch (err) {
      const msg = err?.response?.data?.message || 'Машин нэмэхэд алдаа гарлаа';
      setError(msg);
      showToast(msg, 'error');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal open={true} onClose={onClose} title="Машин нэмэх">
      <form className="form" onSubmit={handleSubmit}>
        <FormField
          type="input"
          label="Машины марк"
          name="mark"
          placeholder="Жишээ: Subaru Forester"
          value={form.mark}
          onChange={handleChange}
          required
        />
        <FormField
          type="input"
          label="Улсын дугаар"
          name="plate"
          placeholder="Жишээ: 1234УБА"
          value={form.plate}
          onChange={handleChange}
          required
        />
        <FormField
          type="input"
          label="Үйлдвэрлэсэн он"
          name="year"
          typeInput="number"
          inputMode="numeric"
          placeholder="Жишээ: 2015"
          value={form.year}
          onChange={handleChange}
          min="1900"
          max={new Date().getFullYear()}
          required
        />
        <button type="submit" disabled={loading} style={{display:'inline-flex',alignItems:'center',gap:6,justifyContent:'center'}}>
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" style={{verticalAlign:'middle'}} xmlns="http://www.w3.org/2000/svg">
            <path d="M5 10.5L8.5 14L15 7" stroke="#222" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
          {loading ? 'Хадгалж байна...' : 'Хадгалах'}
        </button>
        {error && <div style={{ color: 'red', marginTop: 8 }}>{error}</div>}
      </form>
    </Modal>
  );
};

export default AddCarModal;
